import pushToDataLayer, {
  TrackingEvent,
  TrackingInitEvent
} from '@spa/lib/tracking/pushToDataLayer';
import { OptionalStateCarts } from '@spa/lib/store/carts/CartsState';
import { calculateCartQuantities } from '@spa/lib/tracking/calculateCartQuantities';

export const trackMullerInit = (
  cartData: OptionalStateCarts,
  authenticatedUserId: string | null,
  remoteAddress: string | null
): void => {
  if (remoteAddress !== null) {
    const mullerInitEvent: TrackingInitEvent = {
      type: TrackingEvent.APPLICATION,
      event: 'muller.init',
      customerId: authenticatedUserId ?? undefined,
      loggedIn: authenticatedUserId !== null,
      remoteAddress,
      session: {
        cart: calculateCartQuantities(cartData)
      }
    };

    pushToDataLayer(mullerInitEvent);
  }
};

export default trackMullerInit;
